module.exports = __webpack_public_path__ + "static/img/bg-fr.8c425b3f.webp";